import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function ResultsWatchObservable(testEventIDs: number[], modifiedBy: string): Observable<string> {
  const params: string = JSON.stringify({
    TestEventIDS: testEventIDs.map(testEventID => ({ TestEventID: testEventID })),
    ModifiedBy: modifiedBy
  })

  return ObservableFromFetch<string>("FFOrderWatchResolve/Watch", params)
}
